import { getYearSince } from '@shared/utils/get-years-since';

import { Config, PageImageId } from '../../types/page-image';

export const PAGE_IMAGE_CONFIG: Record<PageImageId, Config> = {
  [PageImageId.FalkoZander]: {
    subtitle: `Mehr als ${getYearSince(1993)} Jahre lernen und lehren`,
    sxH1: {
      left: { md: '30vw', xs: '50vw' },
      top: { md: '50%' },
    },
    sxImage: {
      backgroundImage: {
        md: 'url(/img/header-falko-zander.jpg)',
        xs: 'url(/img/header-falko-zander-mobile.jpg)',
      },
    },
    sxWrapper: {
      height: { md: '35vw', xs: '500px' },
    },
    title: 'Falko Zander',
  },

  [PageImageId.Home]: {
    subtitle: 'Neue Perspektiven für Körper, Geist und Seele',
    sxH1: {
      left: { md: '50vw', xs: '40vw' },
      top: { md: '33%' },
    },
    sxImage: {
      backgroundImage: {
        md: 'url(/img/header-mountain.jpg)',
        xs: 'url(/img/header-mountain-mobile.jpg)',
      },
    },
    sxWrapper: {
      height: { md: '40vw', xs: '500px' },
    },
    title: '#COMPANY#NAME&nbsp;-',
  },

  [PageImageId.InstructorProgram]: {
    subtitle: 'Meistere die Kunst des Lehrens',
    sxH1: {
      left: { md: 'auto', xs: '5vw' },
      right: { md: '5vw' },
      top: { md: '60%', xs: '20%' },
    },
    sxImage: {
      backgroundImage: {
        md: 'url(/img/header-training-kampfkunst-selbstverteidigung.jpg)',
        xs: 'url(/img/header-training-kampfkunst-selbstverteidigung-mobile.jpg)',
      },
    },
    sxWrapper: {
      height: { md: '35vw', xs: '500px' },
    },
    title: 'Zertifizierung:',
  },

  [PageImageId.Kampfkunst]: {
    subtitle: 'Gegensätze vereint',
    sxH1: {
      left: { md: 'auto', xs: '5vw' },
      right: { md: '10vw' },
      top: { md: '55%', xs: '60%' },
    },
    sxImage: {
      backgroundImage: {
        md: 'url(/img/header-kampfkunst.jpg)',
        xs: 'url(/img/header-kampfkunst-mobile.jpg)',
      },
    },
    sxWrapper: {
      height: { md: '35vw', xs: '500px' },
    },
    title: 'Systema&nbsp;-',
  },

  [PageImageId.PU]: {
    subtitle: 'Der innere Kreis',
    sxH1: {
      left: { md: 'auto', xs: '5vw' },
      right: '16vw',
      top: { md: '55%', xs: '60%' },
    },
    sxImage: {
      backgroundImage: {
        md: 'url(/img/header-lehre-kampfkunst-falko-zander.jpg)',
        xs: 'url(/img/header-lehre-kampfkunst-falko-zander-mobile.jpg)',
      },
    },
    sxWrapper: {
      height: { md: '35vw', xs: '500px' },
    },
    title: 'VIP-Programm',
  },

  [PageImageId.Ranking]: {
    subtitle: 'Graduierung-System',
    sxH1: {
      left: { md: 'auto', xs: '5vw' },
      right: '5vw',
      top: { md: '60%', xs: '20%' },
    },
    sxImage: {
      backgroundImage: {
        md: 'url(/img/header-training-kampfkunst-selbstverteidigung.jpg)',
        xs: 'url(/img/header-training-kampfkunst-selbstverteidigung-mobile.jpg)',
      },
    },
    sxWrapper: {
      height: { md: '35vw', xs: '500px' },
    },
    title: 'Einzigartig:',
  },

  [PageImageId.Training]: {
    subtitle: 'Dein Weg beginnt!',
    sxH1: {
      left: { md: 'auto', xs: '5vw' },
      right: { md: '5vw' },
      top: { md: '60%', xs: '20%' },
    },
    sxImage: {
      backgroundImage: {
        md: 'url(/img/header-training-kampfkunst-selbstverteidigung.jpg)',
        xs: 'url(/img/header-training-kampfkunst-selbstverteidigung-mobile.jpg)',
      },
    },
    sxWrapper: {
      height: { md: '35vw', xs: '500px' },
    },
    title: 'Training&nbsp;-',
  },

  [PageImageId.Vip]: {
    subtitle: 'Dein Weg zur Meisterschaft',
    sxH1: {
      left: { md: 'auto', xs: '5vw' },
      right: '5vw',
      top: { md: '55%', xs: '60%' },
    },
    sxImage: {
      backgroundImage: {
        md: 'url(/img/header-lehre-kampfkunst-falko-zander.jpg)',
        xs: 'url(/img/header-lehre-kampfkunst-falko-zander-mobile.jpg)',
      },
    },
    sxWrapper: {
      height: { md: '35vw', xs: '500px' },
    },
    title: 'Privatunterricht in Berlin',
  },
};
